import noop from "lodash/noop";
import { useState, useEffect, useCallback } from "react";

import {
  EventDescriptionFieldProps,
  UseDescriptionFieldReturnType,
} from "./types";

export const useDescriptionField = ({
  onChange = noop,
  value = "",
}: EventDescriptionFieldProps): UseDescriptionFieldReturnType => {
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [description, setDescription] = useState<string>(value);

  useEffect(() => {
    // There is an issue using quil & antd modals
    // We need to delay the inital content set till the end of animation
    // https://github.com/zenoamaro/react-quill/issues/814
    if (showDescriptionModal && !description && value) {
      setDescription(value);
    }
  }, [description, showDescriptionModal, value]);

  return {
    onModalConfirm: useCallback(() => {
      onChange(description);
      setShowDescriptionModal(false);
    }, [description, onChange]),
    onModalCancel: useCallback(() => {
      setDescription(value);
      setShowDescriptionModal(false);
    }, [value]),
    openModal: useCallback(() => {
      setShowDescriptionModal(true);
    }, []),
    onDescriptionChange: setDescription,
    description,
    showDescriptionModal,
  };
};
